<template>
  <div class="show">
    <div class="nav">
      关于我们&nbsp;&nbsp;|&nbsp;&nbsp;<a href="#mao"><span>招贤纳士</span><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一</a>
    </div>
    <div class="img-box">
      <img src="../../assets/img/we1.png" alt="">
    </div>
    <div class="img-box2">
      <img src="../../assets/img/we-logo.png" alt="">
      <p>知行车谷是一个基于网络数字化的车类消费聚合服务平台，通过融合线下IP活动和MCN内容的SaaS云服务系统为入驻商家提供精准营销服务， 我们力争通过科技与文化赋能打造中国车类消费领域极具影响力的推广平台，实现以文化带动产业发展的目标。公司先后获得深圳创新投资集团、天津海河产业基金、软通、英诺天使基金等知名投资机构及公司的投资，作为初创公司多次荣获中关村金种子企业、北京市雏鹰企业、国家高新企业、中关村高新企业、中汽协经营模式创新企业、中国汽车后市场总会影响力奖等多种荣誉称号。</p>
      <p>作为平台支撑我司有两个国家行业联盟：中国汽车俱乐部联盟、中国摩托车俱乐部联盟；十余个大型活动IP：英国赛车节、中英汽车文化产业论坛、北京国际摄影周车文化板块、北京市卡丁车公开赛、鄂尔多斯城市车文化节、iAcro潮车节、ACE & CLUB机车节、宝马MINI街角店、ACE-BOX文化市集等；以及近百家泛车类媒体入住的MCN媒体矩阵产品。</p>
      <p>知行车谷是中国汽车工业协会、中国汽车流通协会、中汽摩联、国家电网、中国国际展览中心、奔驰中国、一汽大众、奥迪中国、宝马中国、福特中国、上汽通用、大众汽车集团等公司单位的战略或长期合作伙伴；长期为宝马、奔驰、大众、奥迪、福特、林肯、凯迪拉克、雷克萨斯、丰田、蓝色光标、星传传媒等众多品牌提供咨询、传播与整合营销服务。</p>
    </div>
    <div id="mao"></div>
    <div id="tiao"></div>
    <p class="titou">招贤纳士 欢迎加入</p>
    <div class="img-box3">
        <div class="text-box">
          <p class="p1">电商运营经理</p>
          <p class="p2"><span>1</span>. 店商平台运营老手，玩透电商规则；<br/>2. 打造过无数爆品经历；<br/>3. 擅长数据分析；<br/>4. 敢想、敢干，敢试错；<br/>5. 喜欢车文化。</p>
        </div>
        <div class="text-box">
          <p class="p1">电商客服</p>
          <p class="p2"><span>1</span>. 温柔体贴关爱客户；<br/>2. 耐心、细致，擅长沟通；<br/>3. 聪明、机敏，售前促销量，售后解忧愁；<br/>4. 好学、向上，自制力强；<br/>5. 对车文化感兴趣。</p>
        </div>
        <div class="text-box">
          <p class="p1">产品经理</p>
          <p class="p2"><span>1</span>. 抗压性强，有韧性；<br/>2. 能理解需求，时时复盘验证；<br/>3. 有执行力，懂PRD，UE；<br/>4. 能拆解流程，全方面跑通；<br/>5. 擅交互设计，优化操作体验。</p>
        </div>
        <div class="text-box">
          <p class="p1">项目运营经理</p>
          <p class="p2"><span>1</span>. 有过大型IP活动项目经验；<br/>2. 策划，招商，落地执行样样精通；<br/>3. 善于沟通，优化流程，结果导向；<br/>4. 了解线上+线下运营全流程。</p>
        </div>
        <div class="text-box">
          <p class="p1">招商经理</p>
          <p class="p2"><span>1</span>. 商业谈判小能手，善于挖掘更多资源置换内容；<br/>2. 机敏灵活，变通处理棘手问题；<br/>3. 懂法务，善管理，会算账；<br/>4. 了解汽车，摩托文化。</p>
        </div>
        <div class="text-box">
          <p class="p1">销售经理</p>
          <p class="p2"><span>1</span>. 渠道拓展，资源满满的小天才；<br/>2. 活泼积极，有能力，既独行又可作战；<br/>3. 了解汽车，做一个软件行业小专家；<br/>4. 贴心服务，懂得门店运营。</p>
        </div>
        <div class="text-box">
          <p class="p1">Java 中级工程师</p>
          <p class="p2"><span>1</span>. 用得框架，改得底层；<br/>2. 畅玩 Spring boot ，Cloud都擅长；<br/>3. 能单线程思考，也能多线程并行；<br/>4. 同时服务上万用户请求；<br/>5. 能对技术，能聊需求。</p>
        </div>
        <div class="text-box">
          <p class="p1">Web 工程师</p>
          <p class="p2"><span>1</span>. 百分百还原设计图稿；<br/>2. 心思缜密，构筑最佳交互流程；<br/>3. 满足目标用户的最佳使用体验。</p>
        </div> 

        <div class="text-box">
          <p class="p1">高级平面设计师</p>
          <p class="p2"><span>1</span>. 玩得转PS，AI，搞得定展板、海报设计；<br/>2. 精通Logo，VI设计，能做会用；<br/>3. 有互联网思维，精通新媒体图文排版及H5设计；<br/>4. 懂印刷常识，物料制作流程都上手；<br/>5. 见识广，有想法，汽车、摩托爱好者优先。</p>
        </div>
        <div class="text-box">
          <p class="p1">电商设计</p>
          <p class="p2"><span>1</span>. 懂用户，能提炼产品特点的设计；<br/>2. 对电商产品详情页设计信手拈来；<br/>3. 有打造爆款产品的野心；<br/>4. 点子多，擅创新，喜欢车文化。</p>
        </div>
    </div>
    <p class="hr">简历投递：hr@acegear.com</p>
  </div>
</template>
<script>
export default {
}
</script>

<style lang="scss" scoped>
a{
text-decoration:none;
color:#fff;
}
.show{
  height: 31.8rem;
  width: 100%;
  margin: 0 auto;
  background: url(../../assets/img/we.png) no-repeat;
  background-position: left 0px top -0.8rem;
  background-size: 100% 32.9rem; 
  color: #fff;
  margin-top: .56rem;
  .nav{
  margin-left:12.85rem;
  padding-top: .77rem ;
  cursor:pointer;
  span{
    color: #999;
  }
  }
  .img-box{
    width: 9.6rem;
    height: 5.88rem;
    margin: .5rem auto  0rem;
  }
  .img-box2{
    width: 11.9rem;
    height: 5.66rem;
    margin: 1rem auto  0rem;
    img{
      width: 4.4rem;
      height: .4rem;
      margin: 1rem auto 0rem;
    }
    p{
      width: 11.9rem;
      margin-top: .4rem;
      line-height: .3rem;
      font-size: .2rem;
      text-align: justify;
      word-break: break-all;
      text-justify: distribute;
      text-indent: 2em;
    }
  }
  #mao{
    height: .01rem;
    width: .1rem;
    background: rgba($color: #000, $alpha: 0);
    margin: 0 auto;
    position: relative;
    top: -0.25rem;
  }
  #tiao{
    width: 9.12rem;
    height: .04rem;
    background: #3c3c3c;
    border-radius: .02rem;
    margin: 0.3rem auto 0rem;
  }
  .titou{
      text-align: center;
      font-size: .4rem;
      margin-bottom: .5rem;
      margin-top: .5rem;
    }
  .img-box3{
    width: 10.63rem;
    height: 14.8rem;
    margin: 0 auto ;
    padding-left: 1.8rem;
    overflow: hidden;
    .text-box{
      height: 2.8rem;
      width: 5.3rem;
      float: left;
      .p1{
        font-size: .2rem;
        margin-bottom: .1rem;
      }
      .p2{
        font-size: .2rem;
        span{
          display:inline-block;
          width: .12rem;
          text-align: center;
        }
      }
    }
  }
    .hr{
      text-align: center;
      font-size: .16rem; 
    }
}
</style>
